/* eslint-disable */
import { environmentBase } from './environment.base';
import { IEnvironmentConfiguration } from '../environment.interface';
import { deepMerge } from '@ups/xplat/utils';

export const environmentDev = deepMerge(environmentBase, <
  IEnvironmentConfiguration
>{
  // customizations here...
  environment_name: 'dev',
  appsync: {
    production: true,
    android: {
      productionKey: process.env['AppSync:AndroidKey@prod'],
      stagingKey: process.env['AppSync:AndroidKey@stg'],
    },
    ios: {
      productionKey: process.env['AppSync:IosKey@prod'],
      stagingKey: process.env['AppSync:IosKey@stg'],
    },
    version: '0.0.1',
  },
  name: 'safety',
  urls: {
    spartaAPI: process.env['Urls:SpartaApi@stg'],
    softwareSecurityAPI: process.env['Urls:SecurityApi@stg'],
    fileManagementAPI: process.env['Urls:FileManagementApi@stg'],
    ratesAPI: process.env['Urls:RatesApi@stg'],
    toolTrackerAPI: process.env['Urls:ToolTrackerApi@stg'],
    dynamicAPI: process.env['Urls:DynamicApi@stg'],
    viewpointAPI: process.env['Urls:ViewpointApi@stg'],
    operationsManagementWeb: process.env['Urls:OperationsManagementWeb@stg'],
  },
  blobStorage: {
    url: process.env['Urls:AzureBlobStorageUrl@prod'],
    container: process.env['AzureBlobStorage:ContainerName@stg'],
  },
});
/* eslint-enable */
